import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

export const QUESTION = "Hur långt tillbaka tittar kommunen vid lämplighetsprövning?";
const SHORT_ANSWER = "Vanligen 5–10 år, beroende på brottets karaktär. Ekobrott och narkotikabrott värderas hårdare och längre tillbaka.";

export const Route = createFileRoute("/fraga/hur-lang-tid-tillbaka-tittar-kommunen")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur långt tillbaka tittar kommunen vid lämpligh…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Praxis varierar mellan kommuner. Du bör själv vara öppen om eventuella förekomster i ansökan – kommunen ser dem ändå och tystnad bedöms negativt."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "Lämplighet – tidsperspektiv" }}
      related={[{"to": "/fraga/vad-ar-bulvanforhallanden", "label": "Vad är ett bulvanförhållande?"}, {"to": "/fraga/vem-galler-som-styrelseledamot-vid-pbi-prov", "label": "Räknas alla styrelseledamöter i PBI-kretsen?"}, {"to": "/fraga/far-jag-tillstand-med-tidigare-domar", "label": "Får jag serveringstillstånd om jag har tidigare domar?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur långt tillbaka tittar kommunen vid lämplighetsprövning?" },
      { name: "description", content: "Vanligen 5–10 år, beroende på brottets karaktär. Ekobrott och narkotikabrott värderas hårdare och längre tillbaka." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-lang-tid-tillbaka-tittar-kommunen" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-lang-tid-tillbaka-tittar-kommunen" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-lang-tid-tillbaka-tittar-kommunen",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur långt tillbaka tittar kommunen vid lämpligh…", url: "https://alkoholprovet.se/fraga/hur-lang-tid-tillbaka-tittar-kommunen" },
      ]),
    ],
  }),
});
